import { TCompositionData } from 'types/models/DataAnalysis'

export const toCompositionsChartData = (
  arr: TCompositionData[]
): { rows: any[]; series: { key: string; name: string; color: string }[] } => {
  if (!Array.isArray(arr)) return { rows: [], series: [] }

  const dateMap: Record<string, any> = {}
  const blendTypes = new Set<string>()
  const colorMap: Record<string, string> = {}

  arr.forEach((item) => {
    if (!dateMap[item.date])
      dateMap[item.date] = { period: item.date, parameters: item.parameters }

    item.bins.forEach((bin) => {
      dateMap[item.date][bin.bin_name] = bin.percent
      blendTypes.add(bin.bin_name)
      colorMap[bin.bin_name] = bin.color_hex_code
    })
  })

  const series = Array.from(blendTypes).map((blend) => ({
    key: blend,
    name: blend,
    color: colorMap[blend] ?? '#8884d8',
  }))

  return { rows: Object.values(dateMap), series }
}
